/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './PriorityFeaturesRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getTranslatedPriorityFeatures
 */
export const GET_TRANSLATED_PRIORITY_FEATURES_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getTranslatedPriorityFeatures';
export const GET_TRANSLATED_PRIORITY_FEATURES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TRANSLATED_PRIORITY_FEATURES_QUERY_FIELD_NAME,
  args: ['productApiName', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getTranslatedPriorityFeaturesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getTranslatedPriorityFeaturesBulk
 */
export const GET_TRANSLATED_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getTranslatedPriorityFeaturesBulk';
export const GET_TRANSLATED_PRIORITY_FEATURES_BULK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TRANSLATED_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME,
  args: ['productApiNames', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getTranslatedPriorityFeaturesBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getPriorityFeatures
 */
export const GET_PRIORITY_FEATURES_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getPriorityFeatures';
export const GET_PRIORITY_FEATURES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIORITY_FEATURES_QUERY_FIELD_NAME,
  args: ['productApiName', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPriorityFeaturesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc#getPriorityFeaturesBulk
 */
export const GET_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME = 'com_hubspot_feature_store_rpc_PriorityFeaturesRpc_getPriorityFeaturesBulk';
export const GET_PRIORITY_FEATURES_BULK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRIORITY_FEATURES_BULK_QUERY_FIELD_NAME,
  args: ['productApiNames', 'i18nLangLocale'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getPriorityFeaturesBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});